import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { CommonOfQuantityAndTransaction, StockTransactionGetDto } from 'svila-common';
import { getLocationFromObject, getOrderCustomerName } from '../../../../utils/misc';
import { DATE_FORMAT } from '../../../../utils/constants';
import VerticalValueLabel from './VerticalValueLabel';
import { Colors } from '~/src/scss/common/style';

interface ParamTypes {
  item: CommonOfQuantityAndTransaction;
  children: JSX.Element;
  movementDate?: string;
}
export default function MovementBox({ item, children, movementDate }: ParamTypes): JSX.Element {
  return (
    <>
      <Col>
        <Row>
          <Col style={{ padding: '20px 10px' }}>
            <VerticalValueLabel value={item.totalCuUnits} label="Total Cu Units" />
            <br />
            <VerticalValueLabel value={item.lot ? item.lot : '--'} label="LOT" />
            <br />
            <VerticalValueLabel
              value={item.warehouseLocation !== null ? getLocationFromObject(item.warehouseLocation) : '--'}
              label="Location"
            />
            <br />
            <VerticalValueLabel
              value={item.transactionType === 'Add' && item.warehouseOwner?.name !== 'Svila' ? '--' : item?.sellOrder?.orderNumber ?? '--'}
              label="Order #"
            />
            <br />
            <VerticalValueLabel value={item?.purchaseOrder?.orderNumber ?? '--'} label="Purchase Order #" />
            <br />
            <VerticalValueLabel value={item?.warehouseOwner?.name ?? '--'} label="Warehouse Owner #" />
          </Col>

          <Col style={{ padding: '20px 10px' }}>
            <VerticalValueLabel value={item.fullDuUnits ?? '--'} label="Кашони" />
            <br />
            <VerticalValueLabel value={item.status ?? '--'} label="Status" />
            <br />
            <VerticalValueLabel value={movementDate ?? '--'} label="Movement" />
            <br />
            <VerticalValueLabel
              value={item.sellOrder != null ? moment(item?.sellOrder?.createdOn).format(DATE_FORMAT) : '--'}
              label="Order Date"
            />
            <br />
            <VerticalValueLabel
              value={
                item.purchaseOrder != null ? moment(item?.purchaseOrder?.createdOn).format(DATE_FORMAT) : '--'
              }
              label="Purchase Order Date"
            />
            <br />
            <VerticalValueLabel
              value={item?.warehouse?.name ?? '--'}
              label="Warehouse Name"
            />
          </Col>

          <Col style={{ padding: '20px 10px' }}>
            <VerticalValueLabel value={item.singleDpUnits ?? '--'} label="Дисплеи" />
            <br />
            <VerticalValueLabel value={item.movementType ?? '--'} label="Type" />
            <br />
            <VerticalValueLabel
              value={item.expirationDate ? moment(item.expirationDate).format(DATE_FORMAT) : '--'}
              label="Expiration"
              textStyle={{
                color:
                  moment(item.expirationDate) && moment(item.expirationDate).isBefore()
                    ? Colors.expiredGray
                    : 'initial',
              }}
            />
            <br />
            <VerticalValueLabel
              value={item?.sellOrder ? getOrderCustomerName(item?.sellOrder) : '--'}
              label="Client"
            />
            <br />
            <VerticalValueLabel value={item?.supplier?.name} label="Supplier" longValue />
          </Col>

          <Col style={{ padding: '20px 10px' }}>
            <VerticalValueLabel value={item.singleCuUnits ?? '--'} label="Единици" />
            <br />
            <VerticalValueLabel
              textStyle={{ color: item?.condition === 'Damaged' ? 'red' : '' }}
              value={item?.condition ?? '--'}
              label="Condition"
            />
            <br />
            <VerticalValueLabel
              value={item.productionDate ? moment(item.productionDate).format(DATE_FORMAT) : '--'}
              label="Production"
            />
            <br />
            <VerticalValueLabel value={item.isInvoiced ? 'Yes' : 'No'} label="Invoiced" />
            <br />
            <VerticalValueLabel value={item?.manufacturer?.name} label="Producer" longValue />
          </Col>
        </Row>
      </Col>
      {children && <div style={{ padding: '0', width: '20%' }}>{children}</div>}
      {console.log('children', children)}
    </>
  );
}
